// extracted by mini-css-extract-plugin
export default {"fontFamily":"\"Maax\",\"Helvetica\",\"Arial\",sans-serif","brandPurple":"#6e3264"};